import { useState, useEffect } from "react";
import { MOBILE_WIDTH } from "../App";

interface WindowSizeDTO {
  width: number | undefined;
  height: number | undefined;
}

/**
 * Allows to get current windows size.
 *  
 * @example const windowSize = useWindowSize();
const [isMobile, setIsMobile] = useState<boolean>(false);

useEffect(() => {
  if (windowSize.width && windowSize.width <= 600) {
    setIsMobile(true);
  }
}, [windowSize.width]);
 */
export default function useWindowSize() {
  const [windowSize, setWindowSize] = useState<WindowSizeDTO>({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobileWidth = () => {
    return windowSize.width && windowSize.width < MOBILE_WIDTH;
  };

  return { windowSize, isMobileWidth };
}
